<template>
  <export-link :icon-style="`font-size:1.5rem`"
               :txt-style="`font-size:1.5rem`"
               :class-name="`export-link`"
               style="float: right"
               @export="exportExcel" ref="refExportLink" :lint-title="linkTitle"
               :can-export="userAuth.can_export_summary"/>
</template>

<script>
import {dashboardDownload} from "@/api/dashboard";

export default {
  name: "SummaryExportLink",
  props: {
    params: [Object],
    filename: [String],
    linkTitle: {
      type: String,
      default() {
        return '';
      }
    },
    before: {
      type: [Boolean, Function],
      default() {
        return false;
      }
    },
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    async exportExcel() {
      try {
        let searchCondition
        if (typeof this.before === 'function') {
          searchCondition = this.before()
        } else {
          searchCondition = {...{}, ...this.params}
        }

        let name = null
        if (this.filename === '月度总表') {
          name = `${searchCondition.year}年-${this.filename}`
        } else {
          name = `${searchCondition.year}年${searchCondition.month}月-${this.filename}`
        }
        const response = await dashboardDownload(searchCondition).then(response => {
          return response
        })
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
  }
}
</script>

<style scoped>

</style>
